var prodcat = prodcat || {};

prodcat.data = prodcat.data || {};
var site = site || {};

(function ($) {
  $(document).on('product.skuSelect', '.js-product', function (e, skuBaseId, hasDramming) {
    var $product = $(this);
    var $template = $product.hasClass('js-sticky-add-to-bag')
      ? $(this)
      : $product.siblings('.js-sticky-add-to-bag');
    var $stickyImage = $('.js-sticky-add-to-bag-image', $template);
    var $shadeDot = $('.sticky-add-to-bag__shade-dot', $template);
    var $shadeLabel = $('.js-sku-shade-name', $template);
    var $secondShadeDivider = $('.js-sku-second-divider', $product);
    var $secondShadeName = $('.js-sku-second-shade-name', $product);
    var $secondShadeDot = $('.js-sku-second-shade-dot', $product);
    var $selectedShade = $('.js-product-full-dramming-shades-grid')
      .find('.js-product-full-shades-flyout-list-item.active')
      .not('.secondactive');
    var $selectedSecondShade = $('.js-product-full-dramming-shades-grid').find(
      '.js-product-full-shades-flyout-list-item.secondactive'
    );
    var hasDrammingShadesGrid = $('.js-product-full-dramming-shades-grid')
      .find('li').length === 1 ? true : false;
    var sku = prodcat.data.getSku(skuBaseId);
    var $firstShadeSelect;
    var $firstShadeName;
    var $firstShadeDot;
    var selectedText;
    var defaultsku;

    if ($template.length < 1) {
      return null;
    }

    if (!$product.is($template)) {
      $template.trigger('product.skuSelect', [skuBaseId, hasDramming]);

      return;
    }

    Drupal.behaviors.stickyAddToBagV1.updateHeight($template);
    $template.data('sku-base-id', skuBaseId);

    if ($product.hasClass('js-product-dramming')) {
      $product
        .find('.js-sku-shade-name')
        .removeClass('js-sku-shade-name')
        .addClass('js-sku-first-shade-name');
      $product
        .find('.sticky-add-to-bag__shade-dot')
        .removeClass('sticky-add-to-bag__shade-dot')
        .addClass('sticky-add-to-bag__first-shade-dot js-sku-first-shade-dot');
      $firstShadeName = $('.js-sku-first-shade-name', $product);
      $firstShadeDot = $('.js-sku-first-shade-dot', $product);
      defaultsku = page_data['catalog-spp-dramming']['products'][0].defaultSku;
      $stickyImage.attr('src', defaultsku.IMAGE_LARGE_COMBINED[0]);
      $stickyImage.attr('data-src', defaultsku.IMAGE_LARGE_COMBINED[0]);
    }

    if ($shadeLabel.length) {
      $shadeLabel.html(sku.SHADENAME);
      $shadeLabel.attr('data-inventory-status', sku.INVENTORY_STATUS);
      $shadeLabel.prev().attr('data-inventory-status', sku.INVENTORY_STATUS);
    }

    $shadeLabel.closest('.js-product-full-shades-flyout-trigger')
      .toggleClass('single-shade', hasDrammingShadesGrid);

    // Load with 'select' text and load the default image from bundle sku
    if (hasDramming === 'noshade') {
      $stickyImage.attr('data-src', defaultsku.IMAGE_LARGE_COMBINED[0]);
      selectedText = site.translations.product.spp_dramming_select_text;
      $firstShadeName.html(selectedText);
      $firstShadeSelect = true;
    }

    if ($stickyImage.length && !$product.hasClass('js-product-dramming')) {
      $stickyImage.attr('src', sku.IMAGE_LARGE_COMBINED[0]);
      $stickyImage.attr('data-src', sku.IMAGE_LARGE_COMBINED[0]);
    }
    if ($shadeDot.length) {
      $shadeDot.css('background-color', sku.HEX_VALUE_STRING);
    }
    if ($product.hasClass('js-product-dramming') && hasDramming !== 'noshade' && !hasDramming) {
      $firstShadeName.html($selectedShade.data('shade-name'));
      $firstShadeDot.css('background-color', $selectedShade.data('hex'));
    }
    if ($firstShadeSelect) {
      $firstShadeDot.removeAttr('style');
      $secondShadeDivider.removeClass('hidden');
      $secondShadeDot.removeClass('hidden').removeAttr('style');
      $secondShadeName.html(selectedText).removeClass('hidden');
      $firstShadeSelect = false;
    }
    if (typeof hasDramming !== 'string' && hasDramming) {
      $secondShadeName.html($selectedSecondShade.data('shade-name'));
      $secondShadeDot.css('background-color', $selectedSecondShade.data('hex'));
    }
  });

  Drupal.behaviors.stickyAddToBagV1 = {
    attach: function (context) {
      var $template = $('.sticky-add-to-bag-v1', context);

      if (this.attached || !$template.length) {
        return;
      }
      this.attached = true;

      var self = this;
      var $footer = $('.site-footer', context);
      var $body = $('body', context);
      var $productFull = $('.js-product-full', context);
      var $productFullATB = $productFull.find('.js-product-full-bag-btn');
      var $dataMain = $('.js-product-full__data-main', context);
      var $stickyImage = $('.js-sticky-add-to-bag-image', $template);
      var cr24 = !Drupal?.settings?.global_variables?.cr24 ? false : true;
      var _setPosition = function () {
        var $this = $(window);
        var isMobile = Unison.fetch.now().name === 'small';
        var windowHeight = $this.height();
        var containerHeight = $template.find('.sticky-add-to-bag__container').outerHeight(true);
        var footerOffset = $footer.length ? $footer.offset() : null;
        var scrollTop = $this.scrollTop();
        var dataHeight = $dataMain.height();
        var atbHeight = $productFullATB.height();
        var productFullOffset = $productFull.length ? $productFull.offset() : null;
        var offsetTop = productFullOffset
          ? productFullOffset.top + $productFull.height() - windowHeight + containerHeight
          : 0;
        var offsetBottom = footerOffset && typeof footerOffset.top === 'number'
          ? footerOffset.top - windowHeight
          : Number.POSITIVE_INFINITY;

        if (isMobile && cr24 === false) {
          offsetTop = 0;
        }

        if (cr24 === true && $dataMain.length > 0 && $dataMain.offset()) {
          offsetTop = $dataMain.offset().top + dataHeight + atbHeight;
        }

        self.updateHeight($template);
        if (scrollTop >= offsetTop && scrollTop <= offsetBottom) {
          $body.addClass('sticky-add-to-bag--active');
        } else {
          $body.removeClass('sticky-add-to-bag--active');
        }
      };

      _setPosition();

      $stickyImage.on('lazyloaded load', function (e, data) {
        self.updateHeight($template);
      });

      $(window).on(
        'scroll resize',
        _.throttle(function () {
          _setPosition();
        }, 100)
      );
    },
    updateHeight: function ($template) {
      var containerHeight;
      var $container = $template.find('.sticky-add-to-bag__container');

      if ($template.length === 0 || $container.length === 0) {
        return;
      }
      containerHeight = $container.outerHeight(true);
      $template.height(containerHeight);
    },
    attached: false
  };
})(jQuery);
